import axios from "../axiosInstance";

const piAPI = {
  list: (params) => axios.get("/purchase-invoices", { params }),

  get: (id) => axios.get(`/purchase-invoices/${id}`),

  create: (data) => axios.post("/purchase-invoices", data),

  receive: (id, items) => axios.post(`/purchase-invoices/${id}/receive`, items),

  recordPayment: (id, payment) => axios.post(`/purchase-invoices/${id}/payments`, payment),

  deletePayment: (id, paymentId) => axios.delete(`/purchase-invoices/${id}/payments/${paymentId}`),
};

export default piAPI;
